import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-cuddling',
    templateUrl: './cuddling.component.html',
    styleUrls: ['./cuddling.component.scss'],
    standalone: false
})
export class CuddlingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
